import { buildLegend, buildTooltip, mergePieSettings } from "./shared";
function buildPieSeries(ctx) {
    const { data, settings } = ctx;
    const mergedSettings = mergePieSettings(settings);
    const radius = data.radius ?? mergedSettings.radius ?? ["40%", "70%"];
    const roseType = data.roseType ?? mergedSettings.roseType;
    const showLabels = mergedSettings.showLabels !== false;
    const labelContent = mergedSettings.labelContent ?? "name";
    const sliceGap = mergedSettings.sliceGap ?? 0;
    const formatterFromSetting = (params) => {
        switch (labelContent) {
            case "value":
                return `${params.value}`;
            case "percent":
                return `${params.percent}%`;
            case "nameValue":
                return `${params.name}: ${params.value}`;
            case "namePercent":
                return `${params.name}: ${params.percent}%`;
            case "nameValuePercent":
                return `${params.name}: ${params.value} (${params.percent}%)`;
            case "name":
            default:
                return params.name;
        }
    };
    const labelFormatter = data.labelFormatter
        ? (params) => {
            const datum = data.items.find((item) => item.name === params.name);
            return datum ? data.labelFormatter?.(datum) : formatterFromSetting(params);
        }
        : formatterFromSetting;
    const labelConfig = showLabels
        ? { show: true, formatter: labelFormatter }
        : { show: false };
    const labelLineConfig = showLabels && mergedSettings.labelLine !== false
        ? { show: true, smooth: true }
        : { show: false };
    const itemStyle = {};
    if (typeof mergedSettings.cornerRadius === "number" &&
        mergedSettings.cornerRadius > 0) {
        itemStyle.borderRadius = mergedSettings.cornerRadius;
    }
    if (sliceGap > 0) {
        itemStyle.borderWidth = sliceGap;
        itemStyle.borderColor = "#fff";
        itemStyle.borderJoin = "round";
    }
    return {
        type: "pie",
        radius,
        roseType,
        data: data.items.map((item) => ({
            ...item,
            name: item.name,
            value: item.value,
            itemStyle: item.color ? { color: item.color } : undefined,
        })),
        label: labelConfig,
        labelLine: labelLineConfig,
        hoverOffset: mergedSettings.explode ? 16 : 6,
        selectedOffset: mergedSettings.explode ? 10 : 0,
        itemStyle: Object.keys(itemStyle).length > 0 ? itemStyle : undefined,
    };
}
const pieChartAdapter = {
    type: "pie",
    buildOption: (ctx) => {
        const mergedSettings = mergePieSettings(ctx.settings);
        const option = {
            tooltip: buildTooltip(ctx.data.tooltip, mergedSettings.tooltip),
            legend: buildLegend(ctx.data.legend, mergedSettings.legend),
            series: [buildPieSeries(ctx)],
        };
        return option;
    },
    getDefaultSettings: () => ({
        legend: { show: true, position: "right" },
        tooltip: { enable: true, trigger: "item" },
        radius: ["40%", "70%"],
        showLabels: true,
        labelLine: true,
        explode: false,
        cornerRadius: 0,
        labelContent: "name",
        sliceGap: 0,
    }),
};
export default pieChartAdapter;
